import React from "react";
import { Calendar, ExternalLink } from "lucide-react";
import { useLang } from "../LanguageContext";

const PADLET_URL = "https://padlet.com/EPNsorties/sorties-et-evenements-a-venir-sy2byvxccaotqix2";

export default function Actualites() {
  const { t } = useLang();

  return (
    <div data-testid="page-actualites">
      {/* Padlet calendar callout */}
      <section className="container-page pt-16 sm:pt-24" data-testid="padlet-callout">
        <a
          href={PADLET_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group block rounded-[2rem] bg-forest-light/60 border border-forest-light px-7 sm:px-10 py-7 hover:bg-forest-light transition-colors"
          data-testid="padlet-link"
        >
          <div className="flex flex-col sm:flex-row sm:items-center gap-5">
            <div className="w-12 h-12 rounded-2xl bg-cream-50 text-forest grid place-items-center shrink-0">
              <Calendar size={22} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="eyebrow mb-1">{t("actualites.padlet_eyebrow")}</p>
              <h2 className="font-heading text-xl sm:text-2xl font-semibold text-ink leading-snug">
                {t("actualites.padlet_title")}
              </h2>
              <p className="mt-1.5 text-sm text-ink-muted leading-relaxed">
                {t("actualites.padlet_text")}
              </p>
            </div>
            <div className="shrink-0">
              <span className="inline-flex items-center gap-1.5 rounded-full px-5 py-2.5 bg-forest text-cream-50 text-sm font-medium group-hover:bg-forest-dark transition-colors">
                <ExternalLink size={15} /> {t("actualites.padlet_cta")}
              </span>
            </div>
          </div>
        </a>
      </section>

      <section className="container-page py-10 sm:py-14">
        <p
          className="font-heading text-xl sm:text-2xl text-ink-muted"
          data-testid="news-coming-soon"
        >
          {t("actualites.coming_soon")}
        </p>
      </section>
    </div>
  );
}
